<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">Profile Details</template>
        <div v-if="user">
          <b-row v-if="user.photo" class="py-2 justify-content-md-center">
            <b-col cols="12" class="text-center">
              <img :src="baseURL+'/u/'+user.photo" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.name}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            
           
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.phone">{{user.phone}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="4" md="5">
                  <span class="item_title">Email</span>
                </b-col>
                <b-col cols="8" md="7">
                  <span class="item_value" v-if="user.email">{{user.email}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Role</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.role">{{user.role}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User Status</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.status">{{user.status}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
           
            
            
          </b-row>
        </div>

        <b-row class="justify-content-center">
          <div class="px-2">
            <b-button variant="outline-primary" size="sm" to="/Profile/Edit">Edit</b-button>
          </div>
          <div class="px-2">
            <b-button
              variant="outline-primary"
              size="sm"
              router-link
              to="/changePassword"
            >Change Password</b-button>
          </div>
        </b-row>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: null,
      appLoading: false,
      ServerError: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/me",
        headers: {
          "token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>